/**
 * @type {import("../hooks/useFormValidation").ValidationHandler}
 */
export function focusFirstInvalidInput(result) {
  if (!result.isValid) {
    const firstError = result.errors[0];
    const firstInvalidInput = result.formElement.elements.namedItem(firstError.name);
    if (firstInvalidInput instanceof RadioNodeList) {
      firstInvalidInput[0]?.focus();
    } else {
      firstInvalidInput?.focus();
    }
  }
}

/**
 * @typedef {object} AriaLiveMessageOptions
 * @prop {string | HTMLElement | ((result: import("../hooks/useFormValidation").ValidationResult) => HTMLElement)} target
 * @prop {string | ((result: import("../hooks/useFormValidation").ValidationResult) => string)} [message]
 */

/**
 * @param {AriaLiveMessageOptions} [options]
 * @returns {import("../hooks/useFormValidation").ValidationHandler}
 */
export function updateAriaLiveMessage() {
  let {
    target,
    message = defaultAriaLiveMessage
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return result => {
    const liveRegion = findLiveRegion(target, result);
    if (!liveRegion) {
      return;
    }
    if (result.isValid) {
      liveRegion.textContent = '';
    } else {
      const msg = typeof message === 'function' ? message(result) : message;
      liveRegion.textContent = msg;
    }
  };
}

/**
 * @param {import("../hooks/useFormValidation").ValidationResult} result
 * @returns {string}
 */
function defaultAriaLiveMessage(result) {
  const count = result.errors.length;
  const fields = count === 1 ? 'field' : 'fields';
  const are = count === 1 ? 'is' : 'are';
  return `Failed to submit because ${count} ${fields} ${are} invalid.`;
}

/**
 * @param {AriaLiveMessageOptions['target']} target
 * @param {import("../hooks/useFormValidation").ValidationResult} result
 * @returns {HTMLElement | null}
 */
function findLiveRegion(target, result) {
  if (target instanceof HTMLElement) {
    return target;
  }
  if (typeof target === 'function') {
    return target(result);
  }
  return document.getElementById(target);
}

/**
 * @param {...import("../hooks/useFormValidation").ValidationHandler} handlers
 * @returns {import("../hooks/useFormValidation").ValidationHandler}
 */
export function combine() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }
  return function (result) {
    handlers.forEach(handle => handle(result));
  };
}